import { PriceItem } from '@/common/interfaces/modules/DatesAndRates';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class CabinPrice extends Vue {
  @Prop({ type: Object as () => PriceItem, default: () => ({ Price: '-' }) })
  readonly price!: PriceItem;
}
